import React from 'react';
import PropTypes from 'prop-types';

import { BaseSelect } from 'ui_system/forms/BaseSelect';

import { timezoneList, condensedTimezoneList } from './timezoneList';

// Sort timezones by offset first
const sortedTimezoneKeys = Object.keys(condensedTimezoneList).sort((a, b) => {
  return condensedTimezoneList[b].offset - condensedTimezoneList[a].offset;
});

// Generate options list for BaseSelect
const timezoneOptions = sortedTimezoneKeys.map((identifier) => {
  const { label } = condensedTimezoneList[identifier];
  return {
    value: identifier,
    label,
  };
});

const TimezoneSelect = ({ value, onChange, styles }) => {
  // Find the selected timezone in the condensed or full lists of timezones
  let selectedTimezone = condensedTimezoneList[value];
  if (!selectedTimezone) {
    selectedTimezone = timezoneList[value];
    timezoneOptions.push({ value, label: selectedTimezone.label });
  }

  return (
    <BaseSelect
      value={selectedTimezone}
      onChange={onChange}
      options={timezoneOptions}
      styles={{ container: () => ({ width: '100%' }), ...styles }}
    />
  );
};

TimezoneSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.object,
};

TimezoneSelect.defaultProps = {
  value: null,
  styles: {},
};

export default TimezoneSelect;
